<div class="container">
  <div class="sign-box w-depth">
    <!--Register form-->
    <div class="register-form" *ngIf="form == 'register'">
      <h3>{{'REQUEST.SIGNUP.SIGNUP' | translate}}</h3>
      <form [formGroup]="registerForm">
        <div class="input-field">
          <input type="text" name="displayName" formControlName="displayName" [title]="'INDEX.NAME' | translate"
                 [placeholder]="'INDEX.NAME' | translate">
        </div>
        <div class="input-field">
          <input type="text" name="email" formControlName="email" [title]="'INDEX.EMAIL' | translate"
                 [placeholder]="'INDEX.EMAIL' | translate">
        </div>
        <div class="input-field">
          <input type="password" name="email" formControlName="password" [title]="'INDEX.PASSWORD' | translate"
                 [placeholder]="'INDEX.PASSWORD' | translate">
        </div>
        <div class="input-field">
          <input type="text" name="phone" formControlName="phone" [title]="'INDEX.PHONE' | translate"
                 [placeholder]="'INDEX.PHONE' | translate" [textMask]="{mask: phoneMask}">
        </div>
        <div class="sign-box">
          {{'INDEX.ACCOUNT' | translate}} <span (click)="form = 'signin'">{{'INDEX.SIGN' | translate}}</span>
        </div>
        <div class="form-buttons">
          <button type="button" class="w-btn submit-btn" (click)="submitRegisterForm(registerForm)">
            {{'INDEX.CREATE' | translate}}
          </button>
          <div class="terms-text" [innerHtml]="'INDEX.TERMS' | translate"></div>
        </div>
      </form>
      <app-loader-lock [displayLoader]="showLoading"></app-loader-lock>
    </div>

    <!--Sign in form-->
    <div class="sign-in-form" *ngIf="form == 'signin'">
      <h3>{{'REQUEST.SIGNUP.SIGNIN' | translate}}</h3>
      <form [formGroup]="signInForm">
        <div class="input-field">
          <input type="text" name="phone" formControlName="phone" [title]="'INDEX.PHONE' | translate"
                 [placeholder]="'INDEX.PHONE' | translate" [textMask]="{mask: phoneMask}">
        </div>
        <div class="sign-box">
          {{'INDEX.REGISTER' | translate}} <span (click)="form = 'register'">{{'INDEX.CREATE' | translate}}</span>
        </div>
        <div class="form-buttons">
          <button class="w-btn submit-btn" (click)="submitSignIn(signInForm)">{{'INDEX.SIGN' | translate}}</button>
        </div>
        <app-loader-lock [displayLoader]="showLoading"></app-loader-lock>
      </form>
    </div>

    <!--Verification form-->
    <div class="verification-form" *ngIf="form == 'verification'">
      <h3>{{'REQUEST.SIGNUP.VERIFICATION' | translate}}</h3>
      <h5>{{'INDEX.CODE_TEXT' | translate}} +1 {{phoneVerified | phone}}</h5>
      <div class="change-number">
        <button class="w-link-btn" (click)="form = submittedForm">{{'INDEX.CHANGE' | translate}}</button>
      </div>
      <form [formGroup]="codeForm">
        <div class="input-field">
          <input type="text" name="code" formControlName="code" [title]="'INDEX.CODE' | translate"
                 [placeholder]="'INDEX.CODE' | translate" [textMask]="{mask: verificationCodeMask, guide: false}">
          <button class="w-btn submit-btn" (click)="verifySmsCode(codeForm)">{{'INDEX.VERIFY' | translate}}</button>
        </div>
        <button class="w-btn resend-btn" (click)="sendSMSVerification(phoneVerified, submittedForm)">
          {{'INDEX.RESEND' | translate}}
        </button>
        <app-loader-lock [displayLoader]="showLoading"></app-loader-lock>
      </form>
    </div>
  </div>
</div>
